import React from "react";
import { connect } from "react-redux";
import { switchClientAuth } from "../../actions/UserActions";

const ProfileActions = ({
  SignoutUser,
  setMode,
  _,
  UserProfile,
  switchClient,
  canChangePassword,
}) => {
  const { clients } = UserProfile;
  return (
    <div className="profile-sidebar-actions">
      {clients && clients.length > 1 && (
        <div className="profile-sidebar-actions-btn">
          <select
            className={"form-control"}
            id="switch-client"
            name="switch-client"
            onChange={(e) => switchClient(e.target.value)}
            value={clients.find((f) => f.isDefault).clientId}
          >
            {clients.map((c) => (
              <option
                disabled={!c.isEnabled}
                key={c.clientId}
                value={c.clientId}
              >
                {c.isEnabled
                  ? c.clientName
                  : c.clientName + " (" + _.Disabled + ")"}
              </option>
            ))}
          </select>
        </div>
      )}
      {canChangePassword() && (
        <button
          className="profile-sidebar-actions-btn"
          onClick={(e) => {
            e.preventDefault();
            setMode("ChangePwd");
          }}
        >
          <span className="icon icon-omni-lock" /> {_.ChangePassword}
          <span className="icon-omni-right-arrow-circle right-icon" />
        </button>
      )}
      {canChangePassword() && (
        <button
          className="profile-sidebar-actions-btn"
          onClick={(e) => {
            e.preventDefault();
            setMode("Reset2FAConfig");
          }}
        >
          <span className="icon icon-omni-settings" />{" "}
          {_.TwoFAuth.SidebarMenu.ManageSettings}
          <span className="icon-omni-right-arrow-circle right-icon" />
        </button>
      )}
      <button
        className="profile-sidebar-actions-btn"
        onClick={(e) => {
          e.preventDefault();
          SignoutUser();
        }}
      >
        <span className="icon-omni-logout" /> {_.SignOut}
      </button>
    </div>
  );
};

export const mapStateToProps = (state) => state;
const mapDispatchToProps = (dispatch) => ({
  switchClient: (clientId) => dispatch(switchClientAuth(clientId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileActions);
